import { ExpansionPanel } from '@finn-no/troika-react-expansion-panel';
import { Fragment, type ReactNode } from 'react';
import { connect } from 'react-redux';

import { SpinnerIcon } from 'shared/icons/SpinnerIcon';
import { ApiActionStatus, type Hotel, type HotelOffer, type HotelResults, type PaleState } from '@/interfaces';
import HotelEmptyWarning from '../emptyWarning/HotelEmptyWarning';
import { HotelResultHeader } from './HotelResultHeader';
import { HotelResultItem } from './HotelResultItem';

export type HotelResultListProps = Pick<HotelResults, 'offers' | 'status'> & { hotel: Hotel };

export const HotelResultList = ({ offers, status, hotel }: HotelResultListProps) => {
    const renderOffer = (offer: HotelOffer, index: number): ReactNode => (
        <Fragment key={offer.offerId}>
            {index === 0 && <h2 className="u-t3 u-strong u-mt16">Beste tilbud</h2>}
            {index === 1 && <h2 className="u-t3 u-strong u-mt16">Flere tilbud</h2>}
            <ExpansionPanel
                className="u-ml0 u-mr0 u-mv8"
                data-testid={`HotelResultExpansionPanel-${offer.offerId}`}
                title={<HotelResultHeader {...offer} />}
                expanded={index === 0}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}>
                <HotelResultItem offer={offer} hotel={hotel} />
            </ExpansionPanel>
        </Fragment>
    );

    return (
        <section data-testid="HotelResultList" className="u-position-relative">
            <div>
                {offers.length <= 0 && <HotelEmptyWarning />}
                {offers.map((offer, index) => renderOffer(offer, index))}
            </div>
            {status === ApiActionStatus.PENDING && (
                <div data-testid="resultListOverlay" className="overlay u-bg-milk u-text-center u-opacity075" title="Laster nye tilbud">
                    <SpinnerIcon className="spinner" />
                </div>
            )}
        </section>
    );
};

const mapStateToProps = ({ hotelResults, hotel }: PaleState): HotelResultListProps => ({
    offers: hotelResults.offers,
    status: hotelResults.status,
    hotel,
});

export default connect(mapStateToProps)(HotelResultList);
